import { ArrowDownIcon } from 'assets/icons';
import type { ChangeEvent, FunctionComponent } from 'react';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import type { Country } from 'react-phone-number-input';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import styled from 'styled-components';

const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  height: 44px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.ghostWhite};
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 5px;
  padding-left: 5px;
`;

const StyledReactCountryFlag = styled(ReactCountryFlag)`
  width: 21px;
  height: 18.508px;
`;

const StyledSelect = styled.select`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  border: 0;
  opacity: 0;
  cursor: pointer;
`;

const StyledInfoBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const StyledLabel = styled.p`
  color: ${({ theme }) => theme.colors.deepPurple};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin: 0px;
  padding: 0px;
  margin-right: 9px;
`;

const StyledArrowDownIcon = styled(ArrowDownIcon)`
  width: 8px;
  height: 4px;
  position: absolute;
  right: 10px;
`;

interface CountryInfoProps {
  countryCode: string;
}

const CountryInfo: FunctionComponent<CountryInfoProps> = ({ countryCode }) => (
  <StyledInfoBox>
    <StyledReactCountryFlag countryCode={countryCode} svg />
    <StyledLabel>(+{getCountryCallingCode(countryCode as Country)})</StyledLabel>
    <StyledArrowDownIcon />
  </StyledInfoBox>
);

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
  labels: { [key: string]: string };
}

const CountrySelect: FunctionComponent<CountrySelectProps> = ({ value, onChange, labels }) => (
  <StyledContainer>
    <StyledSelect value={value} onChange={(event: ChangeEvent<HTMLSelectElement>) => onChange(event.target.value || '')}>
      {getCountries().map((country: string) => (
        <option key={country} value={country}>
          {labels[country]} +{getCountryCallingCode(country as Country)}
        </option>
      ))}
    </StyledSelect>
    <CountryInfo countryCode={value} />
  </StyledContainer>
);

export default CountrySelect;
